import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "marginInlineStart", "variant"],
  _excluded2 = ["display", "minBlockSize"];
import { Tag as FoundationsTag } from 'foundations-components/transitional/components/Tag';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { IconContainer } from '../Icons/IconContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const Tag = _ref => {
  let {
      children,
      marginInlineStart = '0',
      variant
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(Object.assign({
    marginInlineStart
  }, restWithSpacingProps));
  return /*#__PURE__*/_jsx(FoundationsTag, Object.assign({}, rest, spacingProps, {
    use: variant,
    children: children
  }));
};
const TagIcon = _ref2 => {
  let {
      display = 'flex',
      minBlockSize = '22px'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(IconContainer, Object.assign({}, rest, {
    display: display,
    minBlockSize: minBlockSize
  }));
};
TagIcon.displayName = 'Tag.Icon';
Tag.Icon = TagIcon;